import React from 'react';

//

const lazyDependencies = {
  ActivityLabDetailPage: React.lazy(() => import('../../../pages/activity-lab-detail')),
  ActivityLabQuizPage: React.lazy(() => import('../../../pages/activity-lab-quiz')),
  AddActivityLabPage: React.lazy(() => import('../../../pages/add-activity-lab')),
  AddAssessmentPage: React.lazy(() => import('../../../pages/add-assessment')),
  AddSubjectPage: React.lazy(() => import('../../../pages/add-subject')),
  AssessmentsPage: React.lazy(() => import('../../../pages/diagnostic-assessments')),
  AssignmentDetailPage: React.lazy(() => import('../../../components/assignments/assignment')),
  AssignmentsPage: React.lazy(() => import('../../../components/assignments')),
  CreateProfilePage: React.lazy(() => import('../../../pages/create-profile')),
  CurrentAssignmentRedirect: React.lazy(() => import('../../../pages/current-assignment')),
  CurrentSubjectAssessmentRedirect: React.lazy(() =>
    import('../../../pages/current-subject-assessment')
  ),
  EssayReviewsPage: React.lazy(() => import('../../../pages/essay-reviews')),
  OnDemandPage: React.lazy(() => import('../../../pages/on-demand')),
  OnDemandCoursePage: React.lazy(() => import('../../../pages/on-demand-course')),
  OrchestratorPage: React.lazy(() => import('../../../pages/orchestrator')),
  DefaultSubjectRedirect: React.lazy(() => import('../../../pages/default-subject')),
  HomePage: React.lazy(() => import('../../../pages/home')),
  SelectProfilePage: React.lazy(() => import('../../../pages/select-profile')),
  SessionRecapsPage: React.lazy(() => import('../../../pages/session-recaps')),
  StudentAgendaPage: React.lazy(() => import('../../../pages/student-agenda')),
  SubjectDetailPage: React.lazy(() => import('../../../pages/subject-detail')),
  TutorChatPage: React.lazy(() => import('../../../pages/tutor-chat')),
};

// Exports
// -------

export default lazyDependencies;
